<template>
  <v-card>
    <v-card-text>
      <file-list
        v-model="attachments"
        :create-file="createIncidentAttachment"
        :disabled="!canEditAttachments"
        :name-folder="`incident-${incidentId}`"
        :remove-file="deleteIncidentAttachment"
        empty-title="Жодного документа немає"
        empty-description="Прикріплюйте докази, звіти, листування"
        main-folder="Операційні ризики"></file-list>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import FileList from '@/components/FileList.vue'
import { useIncident } from '../Incident'

defineOptions({
  name: 'IncidentAttachments',
})

const {
  attachments,
  canEditAttachments,
  createIncidentAttachment,
  deleteIncidentAttachment,
  incidentId,
} = useIncident()
</script>
